import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHighlights = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M114 810L67 763 155 673 140 658Q112 630 112 606 112 583 136 548L213 428 650 47Q683 19 713 19 743 19 771 47L857 133Q884 160 884 191 884 222 857 254L487 696 365 777Q330 801 306 801 283 801 261 779L239 756 184 811ZM431 650L263 480 179 605 306 734ZM20 980L20 910 980 910 980 980Z" })
});
export default SvgHighlights;
